<div class="modal fade" [id]="modalId" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content diff-card">
      <div class="modal-header custom-header">
        <h5 class="modal-title">Comparación de versiones</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Cerrar"></button>
      </div>

      <div class="modal-body">
        @if (loading) {
          <div class="loading">Cargando diferencias...</div>
        } @else if (groupedDiffs.length) {

          <ul class="nav nav-tabs" id="diffTabs" role="tablist">
            @for (group of groupedDiffs; track trackEntity($index, group); let i = $index) {
              <li class="nav-item" role="presentation">
                <button class="nav-link" [class.active]="i === 0"
                        id="tab-{{ i }}" data-bs-toggle="tab"
                        [attr.data-bs-target]="'#content-' + i"
                        type="button" role="tab">
                  {{ group.entity }}
                </button>
              </li>
            }
          </ul>

          <div class="tab-content mt-3">
            @for (group of groupedDiffs; track trackEntity($index, group); let i = $index) {
              <div class="tab-pane fade" [class.show]="i === 0" [class.active]="i === 0"
                   id="content-{{ i }}" role="tabpanel">

                <div class="accordion" id="accordion-{{ i }}">
                  @for (row of group.rows; track trackRow($index, row); let j = $index) {

                    @if (row.rowId) {
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="heading-{{ i }}-{{ j }}">
                          <button class="accordion-button collapsed" type="button"
                                  data-bs-toggle="collapse"
                                  [attr.data-bs-target]="'#collapse-' + i + '-' + j"
                                  aria-expanded="false"
                                  [attr.aria-controls]="'collapse-' + i + '-' + j">
                            {{ row.rowName }}
                          </button>
                        </h2>
                        <div id="collapse-{{ i }}-{{ j }}" class="accordion-collapse collapse"
                             [attr.aria-labelledby]="'heading-' + i + '-' + j"
                             [attr.data-bs-parent]="'#accordion-' + i">
                          <div class="accordion-body">

                            <table class="table table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th style="width: 25%;">Campo</th>
                                  <th style="width: 35%;" class="old-col">Versión Anterior</th>
                                  <th style="width: 35%;" class="new-col">Versión Actual</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (d of row.changes; track trackChange($index, d)) {
                                  <tr>
                                    <td>{{ d.field }}</td>
                                    <td class="old">{{ d.oldValue }}</td>
                                    <td class="new">{{ d.newValue }}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>

                          </div>
                        </div>
                      </div>
                    }

                    @else {
                      <div class="diff-table-wrapper mb-3 border rounded p-2">
                        <h6 class="fw-bold mb-2">
                          {{ row.rowName || 'Cambios generales' }}
                        </h6>
                        <table class="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th style="width: 25%;">Campo</th>
                              <th style="width: 35%;" class="old-col">Versión Anterior</th>
                              <th style="width: 35%;" class="new-col">Versión Actual</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (d of row.changes; track trackChange($index, d)) {
                              <tr>
                                <td>{{ d.field }}</td>
                                <td class="old">{{ d.oldValue }}</td>
                                <td class="new">{{ d.newValue }}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }

                  }
                </div>

              </div>
            }
          </div>

        } @else {
          <p class="no-changes">✅ No se encontraron diferencias entre las versiones.</p>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
